import React from 'react';
import PropTypes from 'prop-types';
import { getDirectionsUrl } from "../../../../helpers/location";
import { Icon, LinkText, Typography } from '../../index';
import './address_link.scss';

export const AddressLink = ({
    address,
    disabled = false,
    splitAddress = false, // sets whether to split street details into separate line from city, state, and zip
    icon, // overrides default address icon size and color
    name,
    onClick = () => { },
    street1Key = "street1",
    street2Key = "street2",
    cityKey = "city",
    stateKey = "state",
    zipKey = "zip",
}) => {

    const getAddressUrl = (address) => {
        const toAddress = (address[street1Key] ? address[street1Key] : '') +
            (address[cityKey] ? ', ' + address[cityKey] : '') +
            (address[stateKey] ? ', ' + address[stateKey] : '') +
            (address[zipKey] ? ' ' + address[zipKey] : '');
        return getDirectionsUrl(null, toAddress);
    }

    const disabledColor = "$color-secondary-a3";
    const hasAddress = (address && address[street1Key]) ? true : false;

    const Element = hasAddress
        ? LinkText
        : 'div';

    const linkProps = hasAddress 
        ? {
            disabled: disabled,
            href: !disabled ? getAddressUrl(address) : '',
            decorator: "mobile",
            target: "_blank"
        }
        : {}

    return (
        <Element
            className="mybswh-address-link"
            onClick={!disabled ? onClick : ''}
            {...linkProps}
        >
            <div className="mybswh-address-link__icon">
                <Icon name="location" size={icon?.size || "medium"} color={disabled ? disabledColor : icon?.color ? icon?.color : "$color-primary-a3"} />
            </div>
            <div className="mybswh-address-link__label">
                {name &&
                    <div className="mybswh-address-link__name">
                        <Typography type="body-01" color={disabled ? disabledColor : ""}>
                            {name}
                        </Typography>
                    </div>
                }
                {hasAddress &&
                    <div className="mybswh-address-link__address">
                        <Typography type="body-01">
                            <span className="mybswh-address__street">{address[street1Key]}</span>
                            {address[street2Key] && <>, <span className="mybswh-address__street2">{address[street2Key]}</span></>}
                            {address[cityKey] && <>, {splitAddress && <br />}<span className="mybswh-address__city">{address[cityKey]}</span></>}
                            {address[stateKey] && <>, <span className="mybswh-address__state">{address[stateKey]}</span></>}
                            {address[zipKey] && <> <span className="mybswh-address__zip">{address[zipKey]}</span></>}
                        </Typography>
                    </div>
                }
                {(!hasAddress && !name) &&
                    <Typography type="heading-01" color={disabled ? disabledColor : "$color-secondary-a2"} >
                        -
                    </Typography>
                }
            </div>
        </Element>
    )
}

AddressLink.propTypes = {
    address: PropTypes.object,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    street1Key: PropTypes.string,
    street2Key: PropTypes.string,
    cityKey: PropTypes.string,
    stateKey: PropTypes.string,
    zipKey: PropTypes.string,
};
